<template>
    <div class="peribox">
        <div style="display: flex">
            <delivery-lead-box-debug :app_id="app_id" :delivery_lead_id="delivery_lead_id"></delivery-lead-box-debug>
            <delivery-agent-lead-debug :app_id="app_id" :delivery_lead_id="delivery_lead_id"></delivery-agent-lead-debug>
            <delivery-agent-log-debug :app_id="app_id" :delivery_lead_id="delivery_lead_id"></delivery-agent-log-debug>
            <delivery-agent-log-text-debug :app_id="app_id" :delivery_lead_id="delivery_lead_id"></delivery-agent-log-text-debug>
        </div>
    </div>
</template>

<script>
import DeliveryLeadBoxDebug from "./delivery-lead-box-debug";
import DeliveryAgentLeadDebug from "./delivery-agent-lead-debug";
import DeliveryAgentLogDebug from "./delivery-agent-log-debug";
import DeliveryAgentLogTextDebug from "./delivery-agent-log-text-debug";

export default {
    components: {DeliveryAgentLogTextDebug, DeliveryAgentLogDebug, DeliveryAgentLeadDebug, DeliveryLeadBoxDebug},
    props: [
        'app_id',
        'delivery_lead_id'
    ],
    data() {
        return {
            rows: null
        };
    },
    methods: {
        refresh() {
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style>
</style>